import React, { forwardRef } from 'react';

const FormInput = forwardRef<
  HTMLInputElement,
  {
    label?: string;
    type?: string;
    name?: string;
    id: string;
    placeholder?: string;
    invalid?: boolean;
    className?: string;
  }
>(
  (
    { label, type, name, id, placeholder, invalid, className, ...props },
    ref
  ) => {
    return (
      <div>
        <label htmlFor={name} className="sr-only">
          {label}
        </label>
        <input
          ref={ref}
          type={type}
          name={name}
          id={id}
          className={
            className
              ? className
              : `shadow-sm block w-full sm:text-sm rounded-md py-4 mt-4 mb-1 ${
                  invalid
                    ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
                    : 'border-gray-300 focus:ring-primary focus:border-primary'
                }`
          }
          placeholder={placeholder}
          {...props}
        />
      </div>
    );
  }
);

FormInput.displayName = 'FormInput';

export default FormInput;
